// javascript
// file: 'src/components/videoPlayer/VideoThumbnail.jsx'
import React, { useEffect, useRef, useState } from "react";
import Loading from "../loading/Loading";

const VideoThumbnail = ({ videoUrl, width = 720, height = 405 }) => {
  const canvasRef = useRef(null);
  const [thumbnail, setThumbnail] = useState(null);
  const [loading, setLoading] = useState(!!videoUrl);

  useEffect(() => {
    if (!videoUrl) return;
    let canceled = false;
    setLoading(true); // yeni video geldiğinde loading başlat

    const video = document.createElement("video");
    video.crossOrigin = "anonymous"; // requires ACAO header from the video host
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto"; // need actual data to draw a frame
    video.src = videoUrl;

    const cleanup = () => {
      video.pause();
      video.removeAttribute("src");
      try {
        video.load();
      } catch {}
    };

    const capture = () => {
      if (canceled) return;
      const canvas = canvasRef.current;
      if (!canvas || !video.videoWidth || !video.videoHeight) return;

      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      // cover fit to avoid stretching
      const vw = video.videoWidth;
      const vh = video.videoHeight;
      const scale = Math.max(width / vw, height / vh);
      const dw = vw * scale;
      const dh = vh * scale;
      const dx = (width - dw) / 2;
      const dy = (height - dh) / 2;

      ctx.fillStyle = "#000";
      ctx.fillRect(0, 0, width, height);

      try {
        ctx.drawImage(video, 0, 0, vw, vh, dx, dy, dw, dh);
        const dataURL = canvas.toDataURL("image/png");
        setThumbnail(dataURL);
        if (!canceled) setLoading(false);
      } catch (e) {
        console.warn("Thumbnail capture failed:", e);
        if (!canceled) setLoading(false); // hatada spinner durmalı
      }
      cleanup();
    };

    const onLoadedMetadata = () => {
      if (canceled) return;

      // Pick a time slightly after 0 to avoid black first frame
      const hasFinite = Number.isFinite(video.duration) && video.duration > 0;
      const targetTime = hasFinite
        ? Math.min(Math.max(0.5, video.duration * 0.02), Math.max(0.9, video.duration - 0.1))
        : 0;

      const tryCapture = () => {
        video.removeEventListener("seeked", tryCapture);
        capture();
      };

      if (hasFinite) {
        video.addEventListener("seeked", tryCapture, { once: true });
        try {
          video.currentTime = targetTime;
        } catch {
          // If seeking not supported, fall back to canplay
          video.addEventListener("canplay", capture, { once: true });
        }
      } else {
        // Live/unknown duration: wait until canplay
        video.addEventListener("canplay", capture, { once: true });
      }
    };

    const onError = (e) => {
      console.warn("Video load error:", e);
      if (!canceled) setLoading(false); // hata durumunda spinner kaldır
      cleanup();
    };

    video.addEventListener("loadedmetadata", onLoadedMetadata);
    video.addEventListener("error", onError);

    return () => {
      canceled = true;
      video.removeEventListener("loadedmetadata", onLoadedMetadata);
      video.removeEventListener("error", onError);
      cleanup();
    };
  }, [videoUrl, width, height]);

  return (
    <>
      <canvas ref={canvasRef} style={{ display: "none" }} />
      {thumbnail ? (
        <div className="thumbnail" style={{ width: "100%", height: "100%", borderRadius: "0px" }}>
          <img
            src={thumbnail}
            alt="Video thumbnail"
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
          <button className="video-play-btn video-popup-activation">
            <i className="icon-18"></i>
          </button>
        </div>
      ) : (<div style={{ width: "100%", height: "100%", background: "#000", position: 'relative', display:'flex', alignItems:'center', justifyContent:'center' }}>
          {loading && <Loading />}
        </div>
      )}
    </>
  );
};

export default VideoThumbnail;

